import React from "react";

import { useTheme } from "styled-components";

import { Box, SectionSubheading } from "@olist/design-system";
import { ProfileOutline, QuestionOutline } from "@olist/design-system-icons";

import { ReasonCard } from "./components";

interface IReasonFormStepProps {
  setStep: (step: "systemForm" | "financialForm") => void;
}

export function ReasonFormStep({ setStep }: IReasonFormStepProps) {
  const theme = useTheme();
  return (
    <Box>
      <SectionSubheading mb="24px" color={theme.text?.primary} bold>
        Sobre o que é seu chamado?
      </SectionSubheading>
      <ReasonCard
        icon={<QuestionOutline width="42px" height="42px" />}
        label="Dúvidas sobre o uso do sistema"
        description="Suporte técnico"
        onClick={() => setStep("systemForm")}
      />
      {/* TODO: Uncomment when "suporte financeiro e da conta" is ready */}
      <ReasonCard
        icon={<ProfileOutline width="28px" height="28px" />}
        label="Mensalidade e informações sobre o meu plano"
        description="Suporte financeiro e da conta"
        onClick={() => setStep("financialForm")}
      />
    </Box>
  );
}
